import { type Ancestor } from '@/modules/hierarchy/api/hierarchy-api'

export function pathChildMap(ancestors: Ancestor[]): Map<string, Ancestor> {
  const pathChild = new Map<string, Ancestor>()
  ancestors.forEach((node, i) => {
    const child = ancestors[i + 1]
    if (child) pathChild.set(node.entityId, child)
  })
  return pathChild
}
